import Api from "./base/api-base";

export default class InquiriesApi {
  //問い合わせ情報一覧取得
  list() {
    return Api.get({
      endpoint: Api.endpoint.inquiries
    });
  }

  //問い合わせ情報取得
  info(id) {
    return Api.get({
      endpoint: Api.endpoint.inquiries,
      id: id,
    });
  }

  //問い合わせステータス情報更新
  update(id, params) {
    return Api.post({
      endpoint: Api.endpoint.inquiries,
      id: id,
      params: params
    });
  }

  //問い合わせ情報登録
  store(params) {
    return Api.post({
      endpoint: Api.endpoint.inquiries,
      params: params
    });
  }
}
